<template>
  <div class="bottom-panel">
    <v-btn
      color="red darken-3"
      class="bottom-panel__action-button white--text"
    >
      {{ buttonText }}
      <i class="bottom-panel__action-icon fas fa-chevron-right"></i>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'BottomPanel',
    props: ['buttonText', 'link']
  }
</script>

<style scoped>
  .bottom-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: flex-start;
    height: 70px;
  }

  .bottom-panel__action-button {
    margin: 0;
    display: flex;
    height: 100%;
    border-radius: 0;
    box-shadow: none !important;
  }

  .bottom-panel__action-button {
    position: relative;
    width: 100%;
    padding-right: 70px;
  }

  .bottom-panel__action-icon {
    position: absolute;
    top: -25px;
    right: -70px;
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    color: #fff;
    background-color: #00796B;
  }
</style>


